var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isCashMode())?[_c('settlementListCash')]:[_c('settlementListCredit')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }